export const PROMPT_BUILDER = 'prompt_builder';
export const JOB_ORDER = 'order';

export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const PROMPT_BUILDER_URL = process.env.REACT_APP_PROMPT_BUILDER;
export const JOB_ORDER_BASE_URL = process.env.REACT_APP_JOB_ORDER_BASE_URL;

export const GOOGLE_OAUTH_URL = process.env.REACT_APP_OAUTH_URL;
export const OAUTH_GOOGLE_CLIENT_ID = process.env.REACT_APP_OAUTH_GOOGLE_CLIENT_ID || '';
